import AdminLayout from '../../components/layout/AdminLayout'
import AdminContentLayout from '../../components/layout/AdminContentLayout'
import MyReportsBox from '../../components/user/MyReportsBox'

const MyReports = () => {
  return (
    <AdminLayout>
      <AdminContentLayout>
        <MyReportsBox />
      </AdminContentLayout>
    </AdminLayout>
  )
}

export default MyReports
